import { render } from "./userList.vue?vue&type=template&id=351835aa&scoped=true"
import script from "./userList.vue?vue&type=script&lang=js"
export * from "./userList.vue?vue&type=script&lang=js"

import "./userList.vue?vue&type=style&index=0&id=351835aa&lang=scss&scoped=true"

import exportComponent from "G:\\web2\\豪哥\\九皇仙府\\admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351835aa"]])

export default __exports__